export const PAYMENT_METHODS_FETCH_STARTED = 'PAYMENT_METHODS_FETCH_STARTED';
export const PAYMENT_METHODS_FETCH_COMPLETED = 'PAYMENT_METHODS_FETCH_COMPLETED';
export const PAYMENT_METHODS_FETCH_FAILED = 'PAYMENT_METHODS_FETCH_FAILED';
